import dynamic from 'next/dynamic';

const PublicLayout = dynamic(() => import('./public-layout'), { ssr: true });
const BlankLayout = dynamic(() => import('./blank-layout'), { ssr: true });
const PrimaryLayout = dynamic(() => import('./primary-layout'), { ssr: true });
const GlobalEffect = dynamic(() => import('@components/common/base/global-effect'), { ssr: false });
const CookieConsentBanner = dynamic(() => import('@components/common/cookie-consent-banner'), { ssr: false });

interface IProps {
  children: any;
  layout?: string;
  authenticate?: boolean;
  noredirect?: boolean;
}

const LayoutMap = {
  primary: PrimaryLayout,
  public: PublicLayout,
  blank: BlankLayout
};

function BaseLayout({ children, layout = '', authenticate, noredirect }: IProps) {
  const Container = layout && LayoutMap[layout] ? LayoutMap[layout] : LayoutMap.primary;
  return (
    <Container authenticate={authenticate} noredirect={noredirect}>
      {children}
      <GlobalEffect />
      <CookieConsentBanner />
    </Container>
  );
}

export default BaseLayout;
